import React, { useContext, useEffect, useState, useRef } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import { NetworkContext } from '../../../context/NetworkContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faPaste } from '@fortawesome/free-solid-svg-icons';
import { ScanLine } from 'lucide-react';

// import { isValidAddress } from '../../../utils/utils';

import CustomButton from '../../Componentization/CustomButton';
import CustomText from '../../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../../store';

import useSecureStorage from '../../../hooks/useSecureStorage';
import useQssWalletAddress from '../../../hooks/useQssWalletAddress';

import i18next from 'i18next'

import WebApp from '@twa-dev/sdk'

/**
 * @brief QSS 지갑주소 추가 페이지
 * @returns 
 */
const QssSettingWalletAddressAdd = () => {
	const { theme } = useContext(ThemeContext)
	const { isValidAddress } = useContext(NetworkContext)

	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { getBlockChain } = useSecureStorage()
	const { addQssWalletAddress } = useQssWalletAddress()
	
    const [isQssWalleNameValid, setIsQssWalleNameValid] = useState(false)
    const [isQssWalleAddressValid, setIsQssWalleAddressValid] = useState(false)

    const [qssWalleNetwork, setQssWalletNetwork] = useState('');
    const [qssWalleName, setQssWalletName] = useState('');
    const [qssWalletAddress, setQssWalletAddress] = useState('');
    
    const [qssWalleNameHelperMessage, setQssWalleNameHelperMessage] = useState('')
    const [qssWalleAddressHelperMessage, setQssWalleAddressHelperMessage] = useState('')
	
	// 버튼 연속 클릭 방지
	const isClickedRef = useRef(false);

    let _network = ''
    let _nickName = ''
    let _walletAddress = ''

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "QssSettingWalletAddressAdd", "title": t('stack_header_message_25') }))
	}, [])

	useEffect(() => {
		const initQssAddPage = async () => {
            // 현제 선택된 네트워크
			const selNetwork = await getBlockChain()
			if(null == selNetwork || '' === selNetwork) {
				setQssWalletNetwork(process.env.REACT_APP_NETWORK_NAME!)
			}
			else {
				setQssWalletNetwork(selNetwork)
			}
		}

		initQssAddPage()
	}, [])

    useEffect(() => {
		validateAddress(qssWalletAddress)
	}, [qssWalletAddress])

    const validateAddress = async (address: string) => {
		let isValid = true
		let message = ''

		if (address.length === 0) {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_16')
		} else if(false === await isValidAddress(address)) {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_17')
		}

		setIsQssWalleAddressValid(isValid)
		setQssWalleAddressHelperMessage(message)
	}
    
    const handleAddQssWalletAddress = async () => {
		try {
			if (isClickedRef.current) {
				console.error('버튼 연속 클릭 차단')
				return;
			}
			isClickedRef.current = true;

			_network = qssWalleNetwork
			_nickName = qssWalleName
			_walletAddress = qssWalletAddress
			// console.log(`QssSettingWalletAddressAdd - handleAddQssWalletAddress : ${_network} | ${_nickName} | ${_walletAddress}`)

			if(true === isQssWalleAddressValid) {
				WebApp.showConfirm(t('qss_setting_wallet_add_message_09'), TgWebAppAddQssWalletAddressCallBack)
			} else {
				WebApp.showAlert(`잘못된 지갑주소 형식 입니다`)
			}
		} catch(error) {
			console.log('Error AddQssWalletAddress', error)
			isClickedRef.current = false;
		} finally {
			// console.log('isClickedRef 상태:', isClickedRef.current)
			// isClickedRef.current = false;
		}
	}

    const TgWebAppAddQssWalletAddressCallBack = async (isSuccess: boolean) => {
        try {
            if(true === isSuccess) {
                if(true === await addQssWalletAddress(_network, _nickName, _walletAddress)) {
                    WebApp.showAlert(t('qss_setting_wallet_add_message_11'), () => {
                        navigate(`/QssSettingWalletAddressScreen`, { replace: true, state: {} });
                    })
                } else {
                    WebApp.showAlert(t('qss_setting_wallet_add_message_10'))
                }
            } else {
            }
			isClickedRef.current = false;
        } catch(error) {
            console.log('Error AddQssWalletAddress CallBack', error)
			isClickedRef.current = false;
            WebApp.showConfirm(t('qss_setting_wallet_add_message_10'))
        }
    }

    // 지갑주소 붙여넣기
    const handlePaseWalletAddress = async () => {
        try {
            // 클립보드에서 텍스트 읽기
            const text = await navigator.clipboard.readText();
            setQssWalletAddress(text) // 복사한 지갑주소 설정
        } catch (error) {
            console.error('Failed to paste text:', error);
        }
    }
    

    const handleQRScan = async () => {
        WebApp.showScanQrPopup({text : 'QRCode를 스캔하시겠습니까?'}, TgWebAppQRCodeCameraCallBack)
    }

    const TgWebAppQRCodeCameraCallBack = (text: string): true | void  => {
        console.log(`TgWebAppQRCodeCameraCallBack : ${text}`)

        setQssWalletAddress(text)

        // true 리턴하면 QR코드 카메라 종료
        return true
    }

	const styles = {
		container: {
			padding: "60px 5px 24px",
			position: "relative"
		} as React.CSSProperties,
		header: {
			width: "100%",
		} as React.CSSProperties,
		body: {
			width: "100%",
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			textAlign: 'left',
			marginBottom: 10
		} as React.CSSProperties,
		subTitle: {
			fontSize: 14,
			textAlign: 'left',
			marginBottom: 5
		} as React.CSSProperties,
		phraseContainer: {
			display: "grid",
			gridTemplateColumns: "repeat(2, 1fr)",
			gap: "10px"
		} as React.CSSProperties,
		warning: {
			marginTop: 15,
			display: "flex",
			alignItems: 'center',
			justifyContent: 'flex-start'
		} as React.CSSProperties,
		warningText2: {
			fontSize: 14,
			textAlign: 'left',
			marginTop: 5
		} as React.CSSProperties,
		footer: {
			width: '100%'
		} as React.CSSProperties,
		button: {
			padding: '12px',
			borderRadius: '10px',
			marginBottom: '12px',
			width: '100%',
			display: "flex",
			alignItems: 'center',
			height: '54px',
			justifyContent: 'center',
		} as React.CSSProperties,
		buttonText: {
			color: theme.static_white,
			fontSize: 16
		} as React.CSSProperties,
		icon: {
			width: 18,
			height: 18,
			marginRight: 5
		} as React.CSSProperties,
		inputRow: {
			display: 'flex',
			alignItems: 'center',
			marginTop: 26
		} as React.CSSProperties,
		helperText: {
			color: 'red',
			fontSize: 12,
			marginTop: 5,
			marginLeft: 0,
			height: 1
		} as React.CSSProperties,
		inputMnemonicName: {
			width: "100%",
			borderTop: "none",
			borderRight: "none",
			borderLeft: "none",
			outline: "none",
			fontSize: 14,
			height: "40px",
			background: "inherit"
		} as React.CSSProperties,
        iconButton: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: "100%"
		} as React.CSSProperties,
		iconText: {
			marginLeft: 5,
			fontSize: 13
		} as React.CSSProperties,
        boxIconScan: {
			width: 15,
			height: 15,
			marginLeft: 10
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_01 }}>
			
			{/* <div style={styles.scrollContainer}> */}
			<div style={styles.header}>
				<CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
					{t('qss_setting_wallet_add_message_01')}
				</CustomText>
				<CustomText style={{ ...styles.subTitle, color: theme.label_strong }}>
					{t('qss_setting_wallet_add_message_02')}
				</CustomText>
			</div>

			<div style={styles.body}>
				<CustomText style={{ ...styles.warningText2, color: theme.label_strong }}>
					{t('qss_setting_wallet_add_message_03')}
				</CustomText>
				<CustomText style={{ ...styles.warningText2, color: theme.label_strong }}>
					{t('qss_setting_wallet_add_message_04')}
				</CustomText>
                <div style={styles.inputRow}>
                    {/* <select
                        value={qssWalleNetwork}
                        onChange={(e) => setQssWalletNetwork(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "10px",
                            fontSize: "16px",
                            border: `1px solid ${theme.label_alternative}`,
                            borderRadius: "5px",
                            background: theme.background_normal,
                            color: theme.label_strong,
                        }}
                    >
                    {items.map((item, index) => (
                        <option value={item.network}>{item.network}</option>    
                    ))}
					</select> */}
                </div>
				<div style={styles.inputRow}>
					<input
						value={qssWalleName}
						onChange={(e) => setQssWalletName(e.target.value)}
						placeholder={i18next.t('qss_setting_wallet_add_message_06')}
						style={{
							...styles.inputMnemonicName,
							borderBottom: `1px solid ${theme.label_alternative}`,
							color: theme.label_strong
						}}
						aria-invalid={!isQssWalleNameValid}
					/>
					<FontAwesomeIcon icon={faPen} color={theme.text_10} />
				</div>
				<p style={styles.helperText}>
					{!isQssWalleNameValid && qssWalleName.length > 0 && (
						qssWalleNameHelperMessage
					)}
				</p>

                <div style={styles.inputRow}>
					<input
						value={qssWalletAddress}
						onChange={(e) => setQssWalletAddress(e.target.value)}
						placeholder={i18next.t('qss_setting_wallet_add_message_07')}
						style={{
							...styles.inputMnemonicName,
							borderBottom: `1px solid ${theme.label_alternative}`,
							color: theme.label_strong
						}}
						aria-invalid={!isQssWalleAddressValid}
					/>
					<FontAwesomeIcon icon={faPaste} color={theme.text_10} onClick={() => handlePaseWalletAddress()} />
				</div>
				<p style={styles.helperText}>
					{!isQssWalleAddressValid && qssWalletAddress.length > 0 && (
						qssWalleAddressHelperMessage
					)}
				</p>
                <button style={styles.iconButton} onClick={handleQRScan}>
					<ScanLine color={theme.text_10} />
                    <CustomText style={{ ...styles.iconText, color: theme.text_10 }}>
                        {i18next.t('template_withdraw_screen_message_04')}
                    </CustomText>
                </button>
			</div>

			<div style={styles.footer}>
				<CustomButton
					containerStyle={{ ...styles.button, backgroundColor: theme.primary_normal }}
					textStyle={styles.buttonText}
					onPress={handleAddQssWalletAddress}
					text={t('qss_setting_wallet_add_message_08')}
					withBackground={true}
					backgroundColor={theme.primary_normal}
				/>
			</div>
			{/* </div> */}
		</div>
	)
}

export default QssSettingWalletAddressAdd
